import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../../Icon";

import "./styles.scss";
import { NavbarModal } from "..";

type Props = { handleModal: (modal: NavbarModal) => void };

const NavBarMobileMenu: FunctionComponent<Props> = ({ handleModal }) => {
  const { sections, searches } = NavbarModal;
  return (
    <div className="navbar-menu">
      <div onClick={() => handleModal(searches)}>
        <Icon iconName="search_icon" className="search-icon__mobile" />
      </div>

      <Link to="/cart">
        <Icon iconName="shopping_bag" className="shopping-bag__mobile" />
      </Link>
      <div onClick={() => handleModal(sections)}>
        <Icon iconName="mobile_navigation_menu" />
      </div>
    </div>
  );
};

export default NavBarMobileMenu;
